import {OwayoJSKonfiViewer} from "../owayoJSViewerWithSelObs";
import {EventVerteiler} from "../../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../../global/GlobalEventnames";
import {TrikotWender} from "./TrikotWender";

export class TrikotWenderKonfi {
    private viewer: OwayoJSKonfiViewer;

    public constructor(viewer: OwayoJSKonfiViewer) {
        this.viewer = viewer;
    }

    einmalWendenBitte(): void {
        EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_CLEARED);
        // @ts-ignore
        TrikotWender.einmalWendenBitte(Object.keys(this.viewer.modelParts), this.viewer.modelObjects, this.viewer.modelParts)
        EventVerteiler.broadcast("recreateAllShadersEvent");
    }
}
